/**
 * Success toast for revokeUserSessions. Nothing on screen changes when the
 * sessions are gone, so both surfaces — the button and the action-menu item
 * — say it happened.
 */
export const USER_REVOKE_SESSIONS_DONE_TITLE =
  "Sessions revoked — the user is signed out everywhere"
